import React from "react";

import { useDiffViewContext } from "src/changeHistory/DiffViewModal/DiffViewContext";
import { JSONSchemaRenderer } from "src/jsonSchema/viewer";
import { createTitleOnlyHeaderRenderer } from "src/jsonSchema/viewer/JSONSchemaRenderer";
import { SchemaOptions } from "src/router/SearchParams";
import {
  getTreeSchemaWithProperty,
  hasJSONTreePreview,
} from "src/schema/jsonRefUtils";
import { PropertyUI } from "src/schema/schemaMappingUtils";

type Props = {
  property: PropertyUI;
  type: SchemaOptions;
  openJsonSchemaWindow?: () => void;
};

export const ObjectFieldRenderer: React.FC<Props> = ({
  property,
  type,
  openJsonSchemaWindow,
}) => {
  const treePreviewSchema = getTreeSchemaWithProperty(property);
  const { renderedInDiffView } = useDiffViewContext();
  if (!hasJSONTreePreview(property, type)) {
    return null;
  }
  return (
    <div className="my-4 rounded-md border border-gray-200 bg-gray-50 p-4">
      <div className="rounded-lg bg-gray-50 p-3">
        <JSONSchemaRenderer
          displayOptions={{
            showPrimitiveTypeLabels: true,
            canCollapse: !renderedInDiffView,
            autoExpandDepth: renderedInDiffView ? 10 : 1,
            customLabelAndTypeRenderer: createTitleOnlyHeaderRenderer(),
            pathEllipsizeDepth: 3,
          }}
          openJsonSchemaWindow={openJsonSchemaWindow}
          schema={treePreviewSchema}
        />
      </div>
    </div>
  );
};
